import { render, staticRenderFns } from "./openOnlineExam.vue?vue&type=template&id=5908f369&scoped=true"
import script from "./openOnlineExam.vue?vue&type=script&lang=js"
export * from "./openOnlineExam.vue?vue&type=script&lang=js"
import style0 from "./openOnlineExam.vue?vue&type=style&index=0&id=5908f369&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5908f369",
  null
  
)

export default component.exports